import { Spacing, Text as TextComponent } from '@billy/design-system'
import styled from '@emotion/styled'

export const ConnectionErrorContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`

export const Text = styled(TextComponent)`
  margin-top: ${Spacing.S16};
`

export const ReconciliationIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${Spacing.S12};
`

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
`
